import { Buttons } from "components";
import { BoxDeleteConfirmStyled } from "./styled";

const BoxDeleteConfirm = ({
  handleConfirm,
  handleCancel,
  textShow = "ยืนยันการลบหรือไม่ ?",
  textBottom,
  labelCancel = "ยกเลิก",
  labelConfirm = "ยืนยัน",
  iconPrefixTitle,
}) => {
  return (
    <BoxDeleteConfirmStyled>
      <div className="title_text">{iconPrefixTitle}{textShow}</div>
      {textBottom && <div className="sub_text">{textBottom}</div>}
      <div className="action_row">
        <div className="btn_wrap">
          <Buttons.BtnNormal
            theme_only_border_blue
            label={labelCancel}
            fontSize="18px"
            paddingButton={'10px'}
            borderRadius="10px"
            fontColor="#002366"
            backgroundColor="#fff"
            onClick={handleCancel}
          />
        </div>
        <div className="btn_wrap">
          <Buttons.BtnNormal
            theme_only_border
            label={labelConfirm}
            fontSize="18px"
            padding="10px"
            borderRadius="10px"
            backgroundColor="#EC5E49"
            fontColor="#fff"
            onClick={handleConfirm}
          />
        </div>
      </div>
    </BoxDeleteConfirmStyled>
  );
};

export default BoxDeleteConfirm;
